<template lang="html">
  <v-container pa-0 ma-0>
    <v-layout row wrap justify-center>
      <div class="">
        <v-layout row wrap justify-center align-center>
          <v-flex
            md10
            lg10
            sm10
            pa-4
            class="bg-box"
            style="
            font-size:16px"
            ;
          >
            <h1 class="title font-weight-bold ta-c" style="font-size:18px">
              โครงการ 100 ล้านกล้า สานต่อรอยพ่อ เพื่อแผ่นดิน<br />
              เฉลิมพระเกียรติ 100 ปี วันพระราชสมภพพระบาทสมเด็จพระบรมชนกาธิเบศร<br />
              มหาภูมิพลอดุลยเดชมหาราช บรมนาถบพิตร
            </h1>
            <div class="ta-c">
              <img src="../assets/images/line.png" alt="" width="250" />
            </div>

            <div v-html="projectDetailHtml"></div>
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "ComponentProject",
  data() {
    return {
      projectDetailHtml: ""
    };
  },
  created() {
    this.fetchProjectDetailHtml();
  },
  methods: {
    fetchProjectDetailHtml() {
      this.axios
        .get(process.env.VUE_APP_IPFLASK + "/projectDetailHtml")
        .then((response) => {
          if (
            response &&
            response.data &&
            typeof response.data.html === "string"
          ) {
            this.projectDetailHtml = response.data.html;
          } else {
            this.projectDetailHtml = "";
          }
        })
        .catch((error) => {
          console.error("Error fetching project detail html:", error);
          this.projectDetailHtml = "";
        });
    }
  }
};
</script>

<style scoped>
.bg-box {
  background-image: url("../assets/images/4873152.jpg");
  background-size: cover;
  background-position: top;
}
</style>
